<template>
  <div class="position-relative w-100 h-100">
    <div class="d-flex justify-content-center align-items-center">
      <div class="mr-1">
        <toolbar-editor-wrap
          :editor-data="editorData"
          :isHideFontStyle="
            editorSelectId == 'privilegeTermEditor' ||
            editorSelectId == 'remarkTextEditer'
          "
          @onChange="onChangeEditorData"
        />
      </div>
      <div @click="editorSelectId ? onUndoEditor() : () => {}">
        <undo-button
          :editor-data="historyData"
          :editor-select-id="editorSelectId"
          :is-active="isActiveValue"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  onBeforeMount,
  reactive,
  ref,
  watch,
  onUpdated,
  getCurrentInstance,
  computed,
} from "@vue/composition-api";
import ToolbarEditorWrap from "./components/CustomQuillEditor.vue";
import UndoButton from "./components/UndoButton.vue";

export default {
  components: { ToolbarEditorWrap, UndoButton },
  props: {
    editorData: { type: Object, default: null },
    historyData: null,
    editorSelectId: null,
  },
  setup(props) {
    const vm = getCurrentInstance().proxy;

    const isActiveValue = computed(() => {
      if (!props.editorSelectId) return;
      if (
        props.historyData[props.editorSelectId] &&
        props.historyData[props.editorSelectId].length > 1
      )
        return true;
      return false;
    });

    const onUndoEditor = () => {
      vm.$emit("onUndo");
    };

    const onChangeEditorData = (event) => {
      vm.$nextTick(() => {
        vm.$emit("onChange", event);
      });
    };

    return { onUndoEditor, onChangeEditorData, isActiveValue };
  },
};
</script>
